import { useCorrespondenceRoute } from "toptaal-shared"
import { correspondenceQueryKeys } from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"
import {
  createFileRoute,
  useNavigate,
  useRouter,
  useSearch,
} from "@tanstack/react-router"
import { CorrespondenceOverview, CorrespondenceThread } from "toptaal-shared"
import {
  getCorrespondenceFilters,
  useCreateCorrespondenceMutation,
  useCurrentStudentSuspenseQuery,
} from "students-api"

export const Route = createFileRoute("/correspondentie/")({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useCurrentStudentSuspenseQuery()

  const handleNavigateToThread = (thread: CorrespondenceThread) => {
    router.navigate({
      to: "/correspondentie/$threadId",
      params: { threadId: thread.id.toString() },
      search: {
        entityType: thread.entityType,
        entityId: thread.entityId,
      },
    })
  }

  const searchParams = useSearch({ from: "/correspondentie/" })
  const navigate = useNavigate({ from: "/correspondentie/" })

  const correspondenceProps = useCorrespondenceRoute({
    entityId: user.userId,
    entityType: "Student",
    queryKey: correspondenceQueryKeys.inbox(),
    queryFn: (filters) => getCorrespondenceFilters(filters),
    useCreateMutation: useCreateCorrespondenceMutation,
    searchParams,
    navigate,
  })

  return (
    <ScreenWrapper className="!px-0 py-8">
      <CorrespondenceOverview
        {...correspondenceProps}
        handleNavigateToThread={handleNavigateToThread}
        contextType="student-inbox"
        canCreateCorrespondence={true}
        correspondencePermission={{
          root: "student",
          roles: ["student"],
          baseUserId: user.baseUserId,
        }}
      />
    </ScreenWrapper>
  )
}
